/*
 *vuex状态管理
 */
import { isNull } from 'lodash';
import Vue from 'vue'
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    user:sessionStorage.getItem('user')?JSON.parse(sessionStorage.getItem('user')):null,
    menus:sessionStorage.getItem('menus')?JSON.parse(sessionStorage.getItem('menus')):null,
    menuActiveIndex:sessionStorage.getItem('menuActiveIndex')?sessionStorage.getItem('menuActiveIndex'):"-1",
    token: localStorage.getItem('token')||'',// 存储token
    navigation:sessionStorage.getItem('navigation')?sessionStorage.getItem('navigation').split(","):null,
    searchStorage:sessionStorage.getItem('search')?JSON.parse(sessionStorage.getItem('search')):null,
  },
  /**
   * 取值方法
   * this.$store.getters.xxx
   **/
  getters:{
    getUser(state){
      return state.user
    },
    getMenus(state){
      return state.menus
    },
    getToken(state){
      return state.token
    },
    getNavigation(state){
      return state.navigation
    },
    getSearchStorage: (state) => (pageName) => {
      if(state.searchStorage == null){
        return null
      }
      let searchObjs = state.searchStorage
      let search = searchObjs[pageName]
      return search
    },
    getMenuActiveIndex(state){
      return state.menuActiveIndex
    }
  },
  /**
   * 赋值方法
   * this.$store.commit('setToken', value);
   **/
  mutations: {
    setUser (state, user) {
      state.user = user;
      var jsonUser = JSON.stringify(user);
      sessionStorage.setItem('user', jsonUser);
    },
    setMenus (state, menus) {
      var jsonMenus = JSON.stringify(menus);
      state.menus = menus;
      sessionStorage.setItem('menus', jsonMenus);
    },
    setToken (state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    setNavigation (state, navigation) {
      var _navigation = navigation.toString();
      state.navigation = navigation;
      sessionStorage.setItem('navigation', _navigation);
    },
    setMenuActiveIndex (state, menuActiveIndex) {
      state.menuActiveIndex = menuActiveIndex;
      sessionStorage.setItem('menuActiveIndex', menuActiveIndex);
    },
    // 保存提供两个方法：保存检索项表单数据 和 保存额外信息（保存内容为对象，已累加的方式变动）
    // 取提供两个方法：取检索项表单数据 和 取额外信息
    setSearchStorage(state, payload){
      if(isNull(payload)){
        state.searchStorage = null
        return
      }
      // 创建整体缓存数据保存对象,各个页面的数据以键值对的方式保存，key为页面值，value为检索项表单数据与额外数据
      let searchObjs = null
      // 创建当前页面的缓存保存对象
      let pageObjs = {}
      // 判断当前是否存在缓存数据，不存在则创建新对象，存在则取出整体缓存数据对象，并获取当前页面的缓存数据
      if(state.searchStorage == null || state.searchStorage == ""){
        searchObjs = new Object()
      } else  {
        searchObjs = state.searchStorage
        if(searchObjs[payload.pageName] != null && typeof(searchObjs[payload.pageName]) != "undefined"){
          pageObjs = searchObjs[payload.pageName]
        }
      }
      // 判断是否传入新的检索项表单数据，存在则覆盖原有的数据
      if(payload.searchOptions != null){
        pageObjs["searchOptions"] = payload.searchOptions
      }
      // 判断缓存是否存在额外信息数据，不存在则直接添加传入的额外信息数据，存在则已存在的数据与传入的数据合并，相同的则覆盖原有的，没有的则加入
      let others = pageObjs["others"]
      if(others == null ){
        if(payload.others!= null){
          pageObjs["others"] = payload.others
        }
      } else {
        pageObjs["others"] = Object.assign(others, payload.others)
      }

      searchObjs[payload.pageName] = pageObjs
      state.searchStorage = searchObjs
      sessionStorage.setItem('search', JSON.stringify(searchObjs))
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js